var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-trust-order-detail',{staticClass:"pt-trust-order-detail__withData",attrs:{"id":_vm.id,"data":_vm.data,"hasTask":_vm.hasTask},on:{"reload":_vm.getBillDetail,"polling-reload":_vm.pollingReload}})
}
var staticRenderFns = []

export { render, staticRenderFns }